import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useWorkspace } from '../lib/WorkspaceContext'

const ETIQUETA_TOMA = { 'mañana': 'Mañana', 'tarde': 'Tarde', 'noche': 'Noche' }

// Suplementos recomendados, dentro de la tab Plan (se movió de Perfil acá:
// decisión de producto, no crear tab de navegación nueva). A diferencia del
// diseño anterior en Perfil, acá dosis/toma van siempre visibles en la card,
// no escondidas detrás del toggle.
export default function SuplementosPlan({ usuario }) {
  const { workspaceActivo } = useWorkspace()
  const [suplementos, setSuplementos] = useState([])
  const [cargando, setCargando] = useState(true)

  useEffect(() => {
    if (!workspaceActivo) { setCargando(false); return }
    cargar()
  }, [workspaceActivo?.id])

  const cargar = async () => {
    setCargando(true)
    const { data, error } = await supabase
      .from('suplementos_config')
      .select('*, suplementos_catalogo(nombre)')
      .eq('paciente_id', usuario.id)
      .eq('workspace_id', workspaceActivo.id)
      .order('created_at')
    if (error) console.error('Error al cargar suplementos asignados:', error)
    setSuplementos(data || [])
    setCargando(false)
  }

  const toggleActivo = async (s) => {
    const { error } = await supabase.rpc('activar_suplemento_paciente', { p_id: s.id, p_activo: !s.activo_paciente })
    if (error) { console.error('Error al activar/desactivar suplemento:', error); return }
    setSuplementos(prev => prev.map(x => x.id === s.id ? { ...x, activo_paciente: !s.activo_paciente } : x))
  }

  if (!workspaceActivo || cargando || suplementos.length === 0) return null

  return (
    <div className="plan-suplementos">
      <p className="page-subtitulo plan-suplementos-titulo">💊 Suplementos recomendados</p>
      {suplementos.map(s => (
        <div key={s.id} className="sos-card plan-suplemento-card">
          <div className="plan-suplemento-header">
            <p className="plan-suplemento-nombre">{s.suplementos_catalogo?.nombre}</p>
            <button
              className={`privacidad-toggle ${s.activo_paciente ? 'activo' : ''}`}
              onClick={() => toggleActivo(s)}
              aria-label={s.activo_paciente ? `Dejar de trackear ${s.suplementos_catalogo?.nombre} a diario` : `Trackear ${s.suplementos_catalogo?.nombre} a diario`}
            >
              <span className="privacidad-toggle-bola" />
            </button>
          </div>
          <p className="plan-suplemento-detalle">
            {s.toma?.length > 0 ? s.toma.map(t => ETIQUETA_TOMA[t] || t).join(', ') : 'Sin momento asignado'}
            {s.dosis ? ` · ${s.dosis}` : ''}
          </p>
          {s.indicaciones && <p className="plan-suplemento-detalle">{s.indicaciones}</p>}
          <p className="plan-suplemento-nota">Al activarlo, empieza a trackearse día a día en tus Hábitos.</p>
        </div>
      ))}
    </div>
  )
}
